module.exports = __webpack_public_path__ + "static/media/9.cfd332b1.jpg";